import { Skill } from 'client/model/skill';

import { Operation } from '../model/operation';

export const getLastOperation = (operations: Operation[], skillId: string) =>
    operations.find((operation) => operation.itemId === skillId);

export const getIsArabicSkillName = (skill: Skill) => {
    if (skill?.draft?.publishingSettings && 'multilingualSettings' in skill.draft.publishingSettings) {
        return Object.keys(skill.draft.publishingSettings.multilingualSettings || {})?.[0] === 'ar';
    }
    return false;
};
